import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import { Tabs } from 'antd-mobile';
import * as styles from './style/index.scss'
import faqImg from '@assets/img/faq.png'
class FAQ extends ComponentExt<any, any> {
    private tabs = [
        { title: '笔记本电脑常见问题', sub: '1' },
        { title: '无线上网伴侣常见问题', sub: '2' },
    ];
    private FAQlIST = [
        { question: '1. SIM卡支持打电话、发短信吗？', answerList: ['SIM卡仅支持数据流量上网功能，不支持语音、短信功能。'] },
        { question: '2. SIM卡支持境外上网吗？', answerList: ['SIM卡仅限中国大陆境内使用，不支持港、澳、台及国际漫游。'] },
        { question: '3. 必须要实名认证后才能使用吗？', answerList: ['工信部要求，SIM卡完成实名认证后，才能正常使用网络。'] },
        { question: '4. 月使用流量是否有限制？', answerList: ['为了保障所有用户的网络公平使用权，用户当月流量累计使用达到套餐订购大小后，上网速率会被降低到128KB/s以下，次月零时自动恢复。'] },
        { question: '5. 如何订购套餐及查询订购记录？', answerList: ['电脑端：开始菜单/任务栏搜索/任务栏网络 > 移动套餐 > 继续 > 首页/流量商城订购 > 个人中心 > 我的订单记录', '小程序端：小程序搜索 > 懂的智能互联 > 首页订购 > 我的 > 我的订单记录'] },
        { question: '6. 套餐订购规则是什么？', answerList: ['订购成功的套餐将根据订购时间自动累计，依次激活，不可退订，不可中止服务。'] },
        { question: '7. 支付方式有什么？', answerList: ['企业端用户可联系经销商进行续费，用户也可自行续费支持微信或支付宝扫码支付。'] },
        { question: '8. 不想使用流量需要怎么关闭？', answerList: ['如果您想关闭流量上网服务，请通过屏幕右下方网络，关闭“手机网络”即可。“手机网络”关闭后计费终止。'] },
        {
            question: '9. 套餐已激活/订购成功，但是无法使用？', answerList: ['请确认您的手机网络是否已打开，路径：点击屏幕右下方“网络图标”> 手机网络 > 连接【Lenovo Connect】；请确认您的套餐是否已订购成功；如账户下有多个设备，请确认订购套餐的号卡ICCID是否与当前使用设备号卡ICCID一致。'],
            img: faqImg
        },
        { question: '10. 打开手机网络，连接【Lenovo Connect】后显示：“无服务”，如何处理？', answerList: ['如果这是您第一次连接手机网络，SIM卡可能需要几分钟才能连接到网络。您可移动您的设备到窗口或开放的区域，以接收更好的信号。'] },
        { question: '11. 打开手机网络，连接【Lenovo Connect】后显示：“无法访问Internet”，如何处理？', answerList: ['1） 如果您是首次连接手机网络，请通过【移动套餐】应用完成注册和实名认证。', '2） 如套餐已激活或新套餐已订购成功，请确认当前套餐是否在有效期内，或您的手机网络是否有信号。'] },
        {
            question: '12. 您打开手机网络，连接【Lenovo Connect】后显示：“无法连接，需要输入接入点”，是什么情况？如何处理？',
            answerList: [
                '1） 该SIM卡与设备为绑定使用，请勿将SIM卡插入其它设备，否则会导致SIM卡锁定无法正常使用。',
                '2） 请重启动设备，如果这没有帮助，您可以通过联想懂的通信微信公众号或拨打联想懂的通信客服热线联系我们的客户服务。',
                '3） 本产品基于该设备出厂时操作系统版本，及根据微软提示的系统升级后的版本提供通信服务，重装操作系统将会造成该通信服务无法正常使用。'
            ]
        },
        { question: '13. 客服联系方式？', answerList: ['微信服务号：联想懂的智联', '客服热线：400-6410041 （工作时间：9:00-18:00）'] },
        { question: '14. 订单发票怎么申请？ ', answerList: ['电脑端：打开移动套餐App > 个人中心 > 我的订单 > 申请开票', '小程序端：小程序搜索 > 懂的智能互联 > 首页订购 > 我的 > 我的订单记录'] },
        {
            question: '15. 如需更换SIM卡，怎么操作？', answerList: [
                '1）SIM卡遗失：您可通过【400-6410041】联系客服进行咨询，在确认问题后给予相应处理。',
                '2） 笔记本+SIM卡遗失：该SIM卡与设备为绑定使用，如设备丢失，则无法操作SIM卡更换新卡。',
                '3） SIM卡损坏、故障：您可通过【400-6410041】联系客服进行咨询，在确认问题后给予相应处理。'
            ]
        },
        { question: '16. 更换SIM卡需要付费吗？ ', answerList: ['更换SIM卡不收取费用。'] },
        { question: '17. SIM卡遗失、损坏或故障期间已激活的套餐可以停用吗？', answerList: ['本产品不支持停用服务，SIM卡遗失、损坏或故障期间已激活或订购成功的套餐不可办理停用服务。'] },
        { question: '18. 移动套餐App忘记密码怎么办？', answerList: ['您可通过登录页的“忘记密码”重置您的密码。'] },
        { question: '19. 号卡ICCID和账号绑定后可以变更吗？ ', answerList: ['可以变更，您可通过【400-6410041】联系客服进行咨询，信息经审核后，客服将解除您现有账号下的号卡ICCID的绑定关系。但是，解绑及再次绑定期间，在套餐有效期内的套餐不支持停用、退订服务。'] },
        { question: '20. SIM卡插入其他设备导致SIM锁定，怎么办？', answerList: ['该SIM卡只能与出厂设备绑定使用，用户因误操作导致SIM卡锁定的，可通过【400-6410041】联系客服进行咨询，在确定设备为联想指定设备后恢复机卡绑定；如客户多次出现机卡分离，联想懂的通信有权关停此号卡上网功能。'] },
        { question: '21. 自行重装系统后，可以正常使用手机网络吗？', answerList: ['本产品基于该设备出厂时操作系统版本，及根据微软提示的系统升级后的版本提供通信服务。如用户自行重装系统将会造成该通信服务无法使用，联想懂的通信不对该情况承担任何责任。'] },
        { question: '22. 若网络弹窗中，手机网络出现非Lenovo connect标识，怎么办？', answerList: ['出现“中国联通”等其他运营商标识后，请通过任务栏搜索“移动套餐”打开软件，并根据软件引导完成实名。'] },
    ]
    private DONGLELIST = [
        { question: '1. 如何判断指示灯网络状态？', answerList: ['1）灯光熄灭，未连接电源', '2）红灯常亮，设备无法正常上网', '3）绿灯常亮，网络可正常使用，Wi-Fi信号开启', '4）蓝灯常亮，网络可正常使用，Wi-Fi信号关闭'] },
        { question: '2. 实名认证后如何激活上网？', answerList: ['完成实名认证后即激活设备，如需快速上网需要重新插拔设备以快速连接，过程中需等待 3-5 分钟属于正常情况，如有激活问题可在激活页面联系人工客服 。'] },
        { question: '3. 如何使用设备网络？', answerList: ['1）从设备侧面取出USB-C连接线，插入笔记本电脑或平板电脑接口，等待设备指示灯显示为绿色即可联网使用', '2）本设备连接电脑或平板时，可作为有线网卡提供有线连接，在系统内显示为本地连接。 当电脑同时连接Wi-Fi时，会优先使用无线上网卡提供的本地连接联网，属于正常情况'] },
        { question: '4. 为何USB-C口插入电脑上没有连接成功？', answerList: ['有部分电脑C口供电不足，请将附带的USB-C转A接口插到设备C口上，再连接到电脑A口上，根据设备指示灯查看设备状态；如还有问题，请联系人工客服解决（查看设备号卡状态）。'] },
        { question: '5. 如何开启网络共享？', answerList: ['新机默认开启无线网络共享功能，使用支持WLAN的设备搜索 Wi-Fi热点即可连接；默认Wi-Fi名称和密码可在设备背面查询，如需修改请进入管理后台或小程序中进行设置。'] },
        { question: '6. 如何修改设备WiFi名称和密码？', answerList: ['1）打开“懂的智能互联”小程序，在“我的”菜单中找到“WiFi密码修改”，进入页面可修改设备WiFi名称和密码', '2）使用连接到本设备的手机或电脑，打开浏览器，在浏览器地址 栏输入管理后台地址:192.168.0.1，输入默认登录密码: admin ，登录后在WiFi设置-主SSID菜单中，修改WiFi名称和密码'] },
        { question: '7. 如何将设备出厂设置？', answerList: ['设备插电工作时，卡针插入机身背面重置孔，长按3-5秒，设备将恢复到出厂状态。'] },
        { question: '8. 设备出厂设置后对套餐有影响吗？', answerList: ['1）出厂设置后，后台管理密码、Wi-Fi名称和密码等设备硬件功能信息将被重置', '2）出厂设置后，网络账户实名信息、流量套餐订阅等服务信息将保留，不受重置影响'] },
        {
            question: '9. 如何注销设备账户？', answerList: ['请联系客服4006410041-2，告诉客服自己需要注销无线上网设备，并告知当前绑定设备的手机号。']
        },
        { question: '10. 如何找到添加的企微客服？', answerList: ['1）在微信中搜索：广东联想懂的通信，找到对应客服人员', '2）联系客服热线：400-6410041-2'] },

        { question: '13. 客服联系方式？', answerList: ['微信服务号：联想懂的智联', '客服热线：400-6410041 （工作时间：9:00-18:00）'] },
        { question: '14. 订单发票怎么申请？ ', answerList: ['电脑端：打开移动套餐App > 个人中心 > 我的订单 > 申请开票', '小程序端：小程序搜索 > 懂的智能互联 > 首页订购 > 我的 > 我的订单记录'] },
    ]
    constructor(props) {
        super(props)
    }
    render(): React.ReactNode {
        return (
            <div className={styles.container}>
                <Tabs tabs={this.tabs}>
                    <div>
                        {
                            this.FAQlIST.map((item, index) => (
                                <div className={styles.FAQItem} key={index}>
                                    <p className={styles.question}>{item.question}</p>
                                    {
                                        item.img && <img src={item.img} className={styles.questionImg} />
                                    }
                                    {
                                        item.answerList.map((subItem, subIndex) => (
                                            <span className={styles.answerItem} key={subIndex}>{subItem}</span>
                                        ))
                                    }
                                </div>
                            ))
                        }
                    </div>
                    <div>
                        {
                            this.DONGLELIST.map((item, index) => (
                                <div className={styles.FAQItem} key={index}>
                                    <p className={styles.question}>{item.question}</p>
                                    {
                                        item.answerList.map((subItem, subIndex) => (
                                            <span className={styles.answerItem} key={subIndex}>{subItem}</span>
                                        ))
                                    }
                                </div>
                            ))
                        }
                    </div>
                </Tabs>

            </div>
        )
    }
}

export default FAQ;
